module.exports = __webpack_public_path__ + "media/application/images/img/overlays/01-0a3750e6fdb29fcd632e627e2fc34dde.png";